import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { PaymentTypesType } from '@bcraft-frontend-lib/payments'
import block from 'bem-cn'

import { getTemplateAmountBySlug } from 'modules/PaymentsPage/__data'

import { selectLocaleDict } from 'features/locale/selectors'

import './TemplateAmount.scss'

type TemplateAmountProps = {
  slug: string
  paymentType: PaymentTypesType
  changeValue(value: number): void
}

const b = block('template-amount')

export const TemplateAmount: React.FC<TemplateAmountProps> = ({ slug, paymentType, changeValue }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).payment
  const templatesByType = useMemo(() => getTemplateAmountBySlug(slug, paymentType), [paymentType, slug])
  const renderItems = useMemo(
    () =>
      templatesByType.map((it, ind) => {
        const onTemplateClick = () => {
          changeValue(it)
        }
        return (
          <div key={`${it}-${ind}`} className={b('item-container')} onClick={onTemplateClick}>
            <div className={b('item-content')}>{String(it).replace('$USER_BALANCE', `${locale.all}`)}</div>
          </div>
        )
      }),
    [changeValue, templatesByType, locale],
  )

  if (!templatesByType.length) return null

  return <div className={b({ paymentType })}>{renderItems}</div>
}
